import { AlloyButton } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';

const ModalButtonCTA = ({
  btnTitle,
  btnType,
  className,
  onClick,
  type,
  icon: Icon
}) => {
  return (
    <AlloyButton
      size="dynamic"
      buttonType={btnType}
      className={className}
      onClick={onClick}
      type={type}
    >
      {Icon && <Icon className="me-2 d-md-none" />}
      {btnTitle}
    </AlloyButton>
  );
};

ModalButtonCTA.propTypes = {
  btnTitle: PropTypes.string,
  btnType: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  icon: PropTypes.string
};

export default ModalButtonCTA;
